import th from './th.1054';
import en from './en.1033';

export default {
    TH: th,
    EN: en,
}
